import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://npaonswjdjtrwhraksnl.supabase.co';
const supabaseKey = 'sb_publishable_5a9ih34WeGpU5tU4ngbWmg_ycZ9Pq2t';

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    flowType: 'implicit',
  },
});